/**
 * Глубокое слияние словарей next-intl: объекты сливаются по ключам, всё остальное
 * берётся из `extra`. Вынесено из `messages-layer.tsx`, потому что тем же слиянием
 * пользуется глобальная регистрация `translateUi` (`shared/lib/ui-translate.ts`):
 * основной словарь не должен затирать группы семейства маршрутов (KAN-975).
 */

export type Messages = Record<string, unknown>;

const isPlain = (v: unknown): v is Messages =>
  typeof v === "object" && v !== null && !Array.isArray(v);

/** Глубокое слияние: объекты сливаются по ключам, всё остальное берётся из `extra`. */
export function mergeMessages(base: Messages, extra: Messages): Messages {
  const out: Messages = { ...base };
  for (const [key, value] of Object.entries(extra)) {
    out[key] = isPlain(value) && isPlain(out[key]) ? mergeMessages(out[key] as Messages, value) : value;
  }
  return out;
}
